// Brand visuals shipped with the frontend (public/img). Keyed by catalog slug — no DB change needed.
// Priority: image uploaded from Admin (served under /api/) > local brand image > legacy stock image_url.
const CATEGORIES = ["home", "ac", "cleaning", "moving", "events", "personal"];
const SERVICES = [
  "electrician", "plumber", "carpenter", "painter", "aluminum", "blacksmith", "glass", "gypsum", "furniture-assembly", "home-maintenance", "renovation", "general-maintenance",
  "ac-repair", "ac-cleaning", "ac-install", "ac-move", "ac-gas", "heating", "water-heater",
  "home-cleaning", "apartment-cleaning", "home-office-cleaning", "move-out-cleaning", "post-construction-cleaning", "carpet-cleaning", "sofa-cleaning", "glass-cleaning",
  "furniture-moving", "items-moving", "trucks", "loading", "city-moving", "intercity-moving",
  "event-planning", "photography", "event-decor", "hospitality", "event-setup", "party-services",
  "home-tutoring", "home-nursing", "gardening", "pest-control", "errands",
];

const isUploaded = (u) => typeof u === "string" && u.startsWith("/api/");

export const categoryImage = (c) => (isUploaded(c?.image_url) ? c.image_url : CATEGORIES.includes(c?.slug) ? `/img/cat/${c.slug}.webp` : c?.image_url || "");
export const serviceImage = (s) => (isUploaded(s?.image_url) ? s.image_url : SERVICES.includes(s?.slug) ? `/img/svc/${s.slug}.webp` : s?.image_url || "");
export const partnerJoinImage = (settings) => (isUploaded(settings?.hero_image) ? settings.hero_image : "/img/partner-join.webp");
export const LOGO_SRC = "/logo.png";
export const logoSrc = (settings) => (isUploaded(settings?.logo_url) ? settings.logo_url : LOGO_SRC);
